module.exports = __webpack_public_path__ + "static/media/tg10.6c0f36dd.jpg";